var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.superAdmin)?_c('v-btn',{attrs:{"small":"","outlined":"","color":"secondary","depressed":""},on:{"click":function($event){return _vm.updateBannerStates()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-refresh ")]),_vm._v(" Refresh Status ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }